import { render, staticRenderFns } from "./ClasificacionVentas.vue?vue&type=template&id=5f1597c0"
import script from "./ClasificacionVentas.vue?vue&type=script&lang=js"
export * from "./ClasificacionVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports